import axios from 'axios';
import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { BACKEND_SERVER_URL } from '../../../http/http-config';
import Select from 'react-select';
import { sortInAlphabeticalOrder } from '../common-helpers/commonServices';


import TinyEditor from '../Common-Components/TinyEditor';
import { validateQuizQuestionData } from '../CommonHelper';
import '../Course/Course.css';
import { generateUniqueID } from '../Course/CourseHelper';
import { set } from 'date-fns';
import DropdownInput from '../Common-Components/DropdownInput';
// import SubjectAndSectionDropdown from './SubjectAndSectionDropdown';

let initialFormData = {
    sn: 0,
    subject: 'Select Subject',
    subjectId: 0,
    section: 'Select Section',
    sectionId: 0,
    topic: 'Select Topic',
    topicId: 0,
    question: '',
    option1: '',
    option2: '',
    option3: '',
    option4: '',
    subjectId: 0,
    sectionId: 0,
    correctAnswer: 'Select Correct Answer',
    description: '',
    quizId: '',
}
const NEET_QuestionBankModal = forwardRef((props, ref) => {
    const [subjects, setSubjects] = useState([]);
    const [sections, setSections] = useState([]);
    const [topics, setTopics] = useState([]);
    console.log('sections', sections);
    console.log('topics', topics);
    const [selectedSubjects, setSelectedSubjects] = useState([]);
    const [selectedSections, setSelectedSections] = useState([]);
    const [selectedTopics, setSelectedTopics] = useState([]);
    const [modalBox, setModalBox] = useState(false);
    const [formData, setFormData] = useState(initialFormData);
    console.log(formData);
    useImperativeHandle(ref, () => ({
        openModal(questionData = {}) {
            setModalBox(true);
            if (questionData.sn) {
                setFormData(questionData)
            } else {
                setFormData((prev) => ({
                    ...prev,
                    ...questionData,
                    quizId: generateUniqueID()
                }));
            }
        }
    }));

    const handleChange = (name, value) => {
        setFormData((previousData) => ({
            ...previousData,
            [name]: value
        }));
    };
    const handleSubmitTest = () => {
        let errorMessgae = validateQuizQuestionData(formData);

        if (errorMessgae) {
            toast.error(errorMessgae)
            return;
        }
        axios.post(BACKEND_SERVER_URL + (formData.sn > 0 ? `/neet/updateQuestion` : '/neet/createQuestion'), formData).then((response) => {
            if (response.data.statusCode == 200) {
                setFormData(initialFormData)
                props.setLoadQuestions(!props.loadQuestions);
                toast.success(response.data.message)
                props.setQuestionOffset(1); // Reset question offset to 1 after successful submission
                setModalBox(false);
            }
        }).catch((error) => {
            toast.error(error.response.data.message)
            console.log(error)
        })

    }
    useEffect(() => {
        if (!modalBox) {
            setFormData(initialFormData); // Reset form data when modal is closed
        }
    }, [modalBox]);



    useEffect(() => {
        if (!modalBox) {
            return;
        }
        const response = axios.all([
            axios.get(BACKEND_SERVER_URL + '/neet/subjects'),
            axios.get(BACKEND_SERVER_URL + '/neet/sections'),
            axios.get(BACKEND_SERVER_URL + '/neet/topics')
        ]);
        response.then(axios.spread((subjectsResponse, sectionsResponse, topicsResponse) => {
            let subjects = subjectsResponse.data.subjects;
            let sections = sectionsResponse.data.sections;
            let topics = topicsResponse.data.topics;
            console.log(sections);
            if (subjects.length > 0 && subjects[subjects.length - 1].Subject === 'All Exam Types') {
                subjects.pop();
            }
            setSubjects(subjects);
            setSections(sections);
            setTopics(topics);
        })).catch((error) => {
            console.log(error);
            toast.error(error.response?.data?.message || "An error occurred while fetching subjects and sections.");
        });

    }, [modalBox])

    useEffect(() => {
        // updated to handle both editing and pre-filled data for new questions
        if (formData.subjectId > 0) {
            let filteredSections = sections.filter(section => section.SubjectID == formData.subjectId);
            setSelectedSections(filteredSections);
        }
        if (formData.sectionId > 0) {
            let filteredTopics = topics.filter(topic => topic.SectionID == formData.sectionId);
            setSelectedTopics(sortInAlphabeticalOrder(filteredTopics, 'Topic'));
        }
    }, [formData.subjectId, formData.sectionId, subjects, sections, topics]);


    const selectSubjectHandler = (selectedSubject) => {
        setFormData((previousData) => ({
            ...previousData,
            subject: selectedSubject.Subject,
            subjectId: selectedSubject.Sn,
        }));
        let filteredSections = sections.filter(subject => subject.SubjectID == selectedSubject.Sn);
        setSelectedSections(filteredSections);
    }
    const selectSectionHandler = (selectedSection) => {
        setFormData((previousData) => ({
            ...previousData,
            section: selectedSection.Section,
            sectionId: selectedSection.Sn,
        }));
        let filteredTopics = topics.filter(topic => topic.SectionID == selectedSection.Sn);
        setSelectedTopics(sortInAlphabeticalOrder(filteredTopics, 'Topic'));
    }
    const selectTopicHandler = (selectedTopic) => {
        setFormData((previousData) => ({
            ...previousData,
            topic: selectedTopic.Topic,
            topicId: selectedTopic.Sn,
        }));
    }
    const styles = {
        control: (provided) => ({
            ...provided,
            width: '100%',
            backgroundColor: 'transparent', // Adjust as needed
            borderColor: '#17a2b8', // Adjust as needed

        }),
    }
    return (
        <>
            <Modal className="" show={modalBox} onHide={setModalBox} dialogClassName="custom-modal-width" backdrop="static"
                keyboard={false} >
                <Modal.Header>
                    <Modal.Title>{formData.sn > 0 ? 'Update Question' : 'Create Question'}</Modal.Title>
                    <Button variant="" className="btn-close" onClick={() => setModalBox(false)}></Button>
                </Modal.Header>
                <Modal.Body>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12 d-flex justify-content-around ">
                                <div className="col-5 d-flex">
                                    <div className="col-sm-4 pt-2">
                                        <div className="mb-3" >
                                            <label htmlFor='news' className="form-label text-primary">Subject<span className="required">*</span></label>
                                        </div>
                                    </div>
                                    <div className="col-sm-8">
                                        <div className="mb-3">
                                            <Select
                                                value={{ value: formData.subject, label: formData.subject }}
                                                onChange={(selectedOption) => selectSubjectHandler(selectedOption.value)}
                                                options={subjects?.map((subject) => ({ value: subject, label: subject.Subject }))}
                                                styles={styles}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-5 d-flex">
                                    <div className="col-sm-4 pt-2">
                                        <div className="mb-3" >
                                            <label htmlFor='news' className="form-label text-primary">Section<span className="required">*</span></label>
                                        </div>
                                    </div>
                                    <div className="col-sm-8">
                                        <div className="mb-3">
                                            <Select
                                                isDisabled={formData.subjectId == 0}
                                                value={{ value: formData.section, label: formData.section }}
                                                onChange={(selectedOption) => selectSectionHandler(selectedOption.value)}
                                                options={selectedSections?.map((section) => ({ value: section, label: section.Section }))}
                                                styles={styles}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 d-flex justify-content-around ">

                                <div className="col-5 d-flex">
                                    <div className="col-sm-4 pt-2">
                                        <div className="mb-3" >
                                            <label htmlFor='news' className="form-label text-primary">Topic<span className="required">*</span></label>
                                        </div>
                                    </div>
                                    <div className="col-sm-8">
                                        <div className="mb-3">
                                            <Select
                                                isDisabled={formData.sectionId == 0}
                                                value={{ value: formData.topic, label: formData.topic }}
                                                onChange={(selectedOption) => selectTopicHandler(selectedOption.value)}
                                                options={selectedTopics?.map((section) => ({ value: section, label: section.Topic }))}
                                                styles={styles}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-5 d-flex">

                                </div>
                            </div>
                            <div className="col-12 ">
                                <div className="d-flex">
                                    <TinyEditor handleChangeCallBack={handleChange} labelName="Question Content" inputValue={formData?.question} inputName='question' />
                                </div>
                            </div>
                            <div className="col-12 ">
                                <div className="d-flex">
                                    <TinyEditor handleChangeCallBack={handleChange} labelName="Option (A)" inputValue={formData?.option1} inputName='option1' editorHeight={200} />
                                </div>
                            </div>
                            <div className="col-12 ">
                                <div className="d-flex">
                                    <TinyEditor handleChangeCallBack={handleChange} labelName="Option (B)" inputValue={formData?.option2} inputName='option2' editorHeight={200} />
                                </div>
                            </div>
                            <div className="col-12 ">
                                <div className="d-flex">
                                    <TinyEditor handleChangeCallBack={handleChange} labelName="Option (C)" inputValue={formData?.option3} inputName='option3' editorHeight={200} />
                                </div>
                            </div>
                            <div className="col-12 ">
                                <div className="d-flex">
                                    <TinyEditor handleChangeCallBack={handleChange} labelName="Option (D)" inputValue={formData?.option4} inputName='option4' editorHeight={200} />
                                </div>
                            </div>
                            <div className="col-12 ">
                                <div className="d-flex">
                                    <TinyEditor handleChangeCallBack={handleChange} labelName="Description" inputValue={formData?.description} inputName='description' />
                                </div>
                            </div>
                            <div className="col-12 ">
                                <div className="d-flex">
                                    <div className="col-5 d-flex ms-4">
                                        <DropdownInput key={1} handleChangeCallBack={handleChange} labelName="Correct Answer" selectedValue={formData?.correctAnswer} inputName='correctAnswer' dropdownValuesArray={['A', 'B', 'C', 'D']} />
                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger light" className='btn-sm' onClick={() => setModalBox(false)}>Close</Button>
                    <Button variant="primary " className='btn-sm ' onClick={handleSubmitTest}>{formData.sn > 0 ? 'Update Question' : 'Create Question'}</Button>
                </Modal.Footer>
            </Modal>

        </>
    )
})
export default NEET_QuestionBankModal;